module.exports = __webpack_public_path__ + "quotes-6e94dd66757754efd2e0.png";